import React from 'react';
import SearchBar from '../../../components/Autosuggest/Autosuggest';
import _ from 'lodash';
import styles from './index.module.scss';
import { IExternalOrder } from 'interfaces/externalOrder';
import { searchItems } from 'services';
import { fetchUserInventoryMapping } from 'services/api/userInventoryMapping';

const propsEqual = (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
};

const SingleOrderItem: React.FC<IExternalOrder.ISingleExternalOrderItemProps> = props => {
  const {
    item,
    index,
    setItem,
    disabled,
    deleteItem,
    userId,
  } = props;
  const handleSuggestionClick = async (suggestion: Record<string, any>) => {
    item.id = suggestion.id;
    item.name = suggestion.displayName;
    item.price = suggestion.price || 0;
    item.quantity = 1;
    const response = await fetchUserInventoryMapping(userId, item.id);
    item.discountPercent = response.discountPercent;
    item.fixedDiscountAmount = response.fixedDiscountAmount;
    setItem(item, index);
  };

  const handleDiscountChange = (value: string) => {
    let discountPercent = parseFloat(value) || '';
    if (discountPercent > 100) {
      discountPercent = '100';
    } else {
      discountPercent = discountPercent.toString();
    }
    setItem({ ...item, discountPercent, fixedDiscountAmount: '0' }, index);
  };

  const handleFixedDiscountChange = (value: string) => {
    setItem({ ...item, fixedDiscountAmount: value, discountPercent: '0' }, index);
  };

  const isDiscountOutOfRange = () => {
    const { price, quantity, discountPercent } = item;
    const itemTotal = price * quantity;
    const itemNetTotal = (itemTotal - (itemTotal * (parseFloat(discountPercent || '0') / 100))).toFixed(2);

    return parseFloat(item.fixedDiscountAmount) > parseFloat(itemNetTotal);
  };

  const handleQuantityChange = (quantity: string) => {
    if (quantity === '') {
      setItem({ ...item, quantity: 0 }, index);
    } else {
      setItem({ ...item, quantity: parseInt(quantity) }, index);
    }
  };

  const calculateTotal = () => {
    const { price, quantity, discountPercent, fixedDiscountAmount } = item;
    const itemTotal = price * quantity;
    let itemNetTotal;
    if (parseFloat(fixedDiscountAmount)) {
      itemNetTotal = itemTotal - parseFloat(fixedDiscountAmount);
    } else {
      itemNetTotal = itemTotal - (itemTotal * (parseFloat(discountPercent || '0') / 100));
    }
    return itemNetTotal.toFixed(2) || 0;
  };

  return (
    <div className={styles['single-item']}>
      <div className={styles['item-name']}>
        <div className={styles['item-number']}>#{index + 1}</div>
        <div className={styles['label']}>Item Name</div>
        <SearchBar
          value={item.name}
          setValue={value => setItem({ ...item, name: value }, index)}
          searchAPI={searchItems}
          searchAPIParam={{ withAvailableStock: true, size: 10 }}
          searchAPIParamKey={'term'}
          onSuggestionClicked={handleSuggestionClick}
        />
      </div>
      <div className={styles['item-price']}>
        <div className={styles['label']}>Price</div>
        <input
          disabled={true}
          value={item.price}
          className={'form-control'}
        />
      </div>
      <div className={styles['item-quantity']}>
        <div className={styles['label']}>Quantity</div>
        <input
          value={item.quantity}
          type={'number'}
          min={1}
          disabled={disabled}
          onChange={e => handleQuantityChange(e.target.value)}
          className='form-control'
        />
      </div>
      <div className={styles['item-discountPercent']}>
        <div className={styles['label']}>Discount (%)</div>
        <input
          className={'form-control'}
          type={'number'}
          disabled={disabled}
          min={0}
          max={100}
          value={item.discountPercent}
          onChange={e => handleDiscountChange(e.target.value)}
        />
      </div>
      <div className={styles['item-discountPercent']}>
        <div className={styles['label']}>Flat Discount</div>
        <input
          className={`form-control ${isDiscountOutOfRange() ? styles['out-of-range'] : ''}`}
          type={'number'}
          disabled={disabled}
          step={0.01}
          min={0}
          max={100}
          value={item.fixedDiscountAmount}
          onChange={e => handleFixedDiscountChange(e.target.value)}
        />
      </div>
      <div className={styles['item-total']}>
        <div className={styles['total']}>
          <div className={styles['label']}>Item Total</div>
          <input
            className={'form-control'}
            type={'number'}
            disabled={true}
            value={calculateTotal()}
          />
        </div>
        <div className={styles['delete']}>
          <i
            onClick={() => deleteItem(index)}
            className='fa fa-trash-o'
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(SingleOrderItem, propsEqual);
